import React, { memo } from 'react';

import Modal, { type ModalProps } from '@fmbt/ui/Modal';

export type WarningModalProps = Pick<
  ModalProps,
  | 'children'
  | 'confirmText'
  | 'dismissText'
  | 'isConfirmButtonLoading'
  | 'isOpen'
  | 'onConfirm'
  | 'onDismiss'
  | 'size'
  | 'title'
>;

/**
 * Destructive confirmation preset — warning icon, red confirm button, row footer.
 */
function WarningModal(props: WarningModalProps) {
  return (
    <Modal
      {...props}
      isConfirmButtonDangerous
      showWarningIcon
    />
  );
}

export default memo(WarningModal);
